import { login, logout, getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'
import {Message} from "@femessage/element-ui";

const state = {
  token: getToken(),
  id: 0,
  userInfo: {
    type: 0,
    avatar: '',
    realname:'',
    mobile: '',
    showId: '',
    companyName:'',
  },
  company:{},
  msgCount: 0,
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  routes: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_USER_INFO: (state, userInfo) =>{
    state.userInfo = userInfo
  },
  SET_ID: (state, id) => {
    state.id = id
  },
  SET_MSG_COUNT: (state, msgCount) => {
    state.msgCount = msgCount
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_ROUTES: (state, routes) => {
    state.routes = routes
  },
  SET_COMPANY: (state, company) => {
    state.company = company
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password, vercode } = userInfo
    return new Promise((resolve, reject) => {
      login(userInfo).then(response => {
        console.log('loginResponse', response)
        if (response.code !== 1) {
          Message.error(response.msg)
          return reject(response)
        }
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { data } = response

        if (!data) {
          reject('Verification failed, please Login again.')
        }

        const { roles, name, avatar, introduction, routes } = data

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!')
        }

        commit('SET_USER_INFO', data.userInfo)
        commit('SET_ROLES', roles)
        commit('SET_ID', data.id)
        commit('SET_MSG_COUNT', data.msgCount || 0)
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_INTRODUCTION', introduction)
        commit('SET_ROUTES', routes)
        commit('SET_COMPANY', data.company)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updateCompany({ commit }, company) {
    commit('SET_COMPANY', company)
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_USER_INFO', {})
        commit('SET_ID', 0)
        removeToken()
        resetRouter()

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        // dispatch('tagsView/delAllViews', null, { root: true })

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const { roles } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    // dispatch('tagsView/delAllViews', null, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
